import {ReactComponent as TextSnippetIcon} from "../icons/TextSnippet24.svg";
import Alert from "@mui/material/Alert";
import Link from "@mui/material/Link";

const TextAlert = ({ type, url, text }) => {
  return (
    <Alert icon={<TextSnippetIcon sx={{color:"#ffffff"}} />} severity="info" sx={{backgroundColor:"#241773", color:"#ffffff", fontSize:"18px"}}>
      <Link sx={{color:"#ffffff", textDecorationColor:"#ffffff", cursor:"pointer"}} href={url} target="_blank" >
        {type}: {text}
      </Link>
    </Alert>
  );
};

export default TextAlert;
